import { Box, Button, Container, Heading, Image, Input, Select, Spinner, Stack, Table, Tbody, Td, Text, Thead, Tr } from '@chakra-ui/react'
import React from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import SectionHeading from '../components/SectionHeading'
import { selectedOrder } from '../reducers/useReducers'
import DonatePic from '../assets/images/donatePic.png'
import { GET } from '../utilities/ApiProvider'
import { baseUrl } from '../utilities/customUrls'
import { useEffect } from 'react'

export default function OnlineDonate() {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [items, setItems] = useState([]);

    const [moreItems, setmoreItems] = useState([]);

    const [photoGallery, setPhotoGallery] = useState([]);
    const [isLoading, setisLoading] = useState(false);

    const getPhotoGallery = async () => {
        setisLoading(true);
        let dynamicPhotoGallery = await GET(`${baseUrl}/DonationCategory`,
            { authorization: `Basic ${btoa('admin:admin123')}` })
        // console.log(dynamicPhotoGallery);
        setItems(dynamicPhotoGallery?.Data[0]?.DonationItems)
        var newData = dynamicPhotoGallery?.Data;
        newData.shift();
        setmoreItems(newData);
        // console.log(newData);
        setisLoading(false);
    }

    useEffect(() => {
        getPhotoGallery();
    }, [])

    const [itemValue, setItemValue] = useState('');
    const [price, setPrice] = useState(0);
    const [bankCharges, setBankCharges] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        let tempTotal = (price * quantity);
        setBankCharges(Math.ceil(tempTotal * 0.03));
        tempTotal = tempTotal + (tempTotal * 0.03);
        setTotal(tempTotal)
    }, [price, quantity])


    return (
        <Stack
            paddingY={'80px'}
        >

            <Container
                maxW={'2xl'}
            >
                {/* <Image src={DonatePic} alt={'donate pic'} w={'500px'} marginX={'auto'} marginBottom={'40px !important'} /> */}
                <Stack
                    pb={12}
                >
                    <SectionHeading width={'100%'} smallHeading={"Online Donation"} mainHeading={'Featured Items'} marginPosition={'auto'} textAlignment={'center'} />
                </Stack>
                {
                    isLoading ?
                        <Stack
                            w={'100%'}
                            justifyContent={'center'}
                        >
                            <Spinner color={'#000'} />
                        </Stack>
                        :
                        <>
                            <Stack
                                direction={'row'}
                                alignItems={'center'}
                                flexWrap={'wrap'}
                                spacing={0}
                                paddingBottom={'35px'}
                                borderBottom={'1px solid'}
                                borderColor={'#adadad'}
                            >

                                {
                                    items?.map((v, i) =>
                                        <Box
                                            key={i}
                                            w={'33%'}
                                            textAlign={"center"}
                                            padding={'10px'}
                                            marginBottom={"10px !important"}
                                            shadow={'base'}
                                        >
                                            <Button
                                                _hover={{
                                                    background: 'transparent'
                                                }}
                                                background={'transparent'}
                                                padding={0}
                                                onClick={() => {
                                                    // console.log('ran');
                                                    dispatch(selectedOrder(v))
                                                    navigate(`/donation`)
                                                }}
                                            >
                                                - {v?.Title}
                                            </Button>
                                        </Box>
                                    )
                                }
                            </Stack>
                            <Stack
                                direction={'row'}
                                alignItems={'center'}
                                flexWrap={'wrap'}
                                spacing={0}
                                marginTop={'30px !important'}
                            >

                                {
                                    moreItems?.map((v, i) =>
                                        <Box
                                            padding={'15px'}
                                            key={i}
                                            w={'45%'}
                                            textAlign={"left"}
                                            marginBottom={"10px !important"}
                                            shadow={'base'}
                                            margin={'15px !important'}
                                        >
                                            <Heading fontSize={'22px'} paddingBottom={'30px'}>{v?.Text}</Heading>
                                            {
                                                v?.DonationItems?.map((v, i) => {
                                                    return (
                                                        <Button
                                                            _hover={{
                                                                background: 'transparent'
                                                            }}
                                                            background={'transparent'}
                                                            padding={0}
                                                            onClick={() => {
                                                                // console.log('ran');
                                                                dispatch(selectedOrder(v))
                                                                navigate(`/donation`)
                                                            }}
                                                        >
                                                            - {v?.Title}
                                                        </Button>
                                                    )
                                                })
                                            }
                                        </Box>
                                    )
                                }
                            </Stack>
                        </>
                }

            </Container>
            <Stack
                pb={12}
            >
                <SectionHeading width={'100%'} smallHeading={"Online Donation"} mainHeading={'Calculator'} marginPosition={'auto'} textAlignment={'center'} />
                <Stack
                    pt={12}
                >
                    <Container maxW={'6xl'}>
                        <Stack>
                            <Stack
                                direction={'row'}
                                alignItems={'center'}
                                gap={0}
                                border={'1px solid #1fbdd0'}
                                borderBottom={0}
                                p={3}
                            >
                                <Box w={'20%'}>Items</Box>
                                <Box w={'20%'}>Price</Box>
                                <Box w={'20%'}>Quantity</Box>
                                <Box w={'20%'}>Bank Charges</Box>
                                <Box w={'20%'}>Total</Box>
                            </Stack>
                            <Stack
                                marginTop={'0px !important'}
                                p={3}
                                direction={'row'}
                                alignItems={'center'}
                                border={'1px solid #1fbdd0'}
                            >
                                <Box w={'20%'}>
                                    <Select>
                                        <option value={'sadqa'}>Sadqa</option>
                                        <option value={'zakat'}>Zakat</option>
                                    </Select>
                                </Box>
                                <Box w={'20%'}>
                                    <Input onChange={(e) => setPrice(e.target.value)} />
                                </Box>
                                <Box w={'20%'}>
                                    <Input value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                                </Box>
                                <Box w={'20%'}>
                                    <Input readOnly value={`3% -> ${bankCharges}`} />
                                </Box>
                                <Box w={'20%'}>
                                    <Input readOnly value={total} />
                                </Box>
                            </Stack>
                        </Stack>
                        {/* <Table
                            className='table'
                        >
                            <Thead>
                                <Tr>
                                    <Td>Items</Td>
                                    <Td>Price</Td>
                                    <Td>Qty</Td>
                                    <Td>Bank Charges</Td>
                                    <Td>Total</Td>
                                </Tr>
                            </Thead>
                            <Tbody>
                                <Tr>
                                    <Td>
                                        
                                    </Td>
                                    <Td>
                                    </Td>
                                    <Td>
                                    </Td>
                                    <Td>
                                    </Td>
                                    <Td>
                                    </Td>
                                </Tr>
                            </Tbody>
                        </Table> */}
                    </Container>
                </Stack>
            </Stack>
        </Stack>
    )
}
